import { Validateable } from "./interfaces/validateable";

export abstract class TermsAndPrivacy extends Validateable {
	private privacy_policy: boolean = false;
	private terms_accepted: boolean = false;

	public getPrivacyPolicyAccepted(): boolean {
		return this.privacy_policy;
	}

	public getTermsAccepted(): boolean {
		return this.terms_accepted;
	}

	public get _privacy_policy(): boolean {
		return this.privacy_policy;
	}

	public set _privacy_policy(b: boolean) {
		this.privacy_policy = b;
	}

	public get _terms_accepted(): boolean {
		return this.terms_accepted;
	}

	public set _terms_accepted(b: boolean) {
		this.terms_accepted = b;
	}
}
